import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ThemeProvider from "./components/feature/ThemeProvider";
import Seo from "./components/feature/Seo";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <Seo />
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;